import { useId } from 'react'
import { ETIQUETAS, TEMAS } from './tema'
import { useTema } from './useTema'

interface Props {
  /**
   * En la barra lateral el rotulo se ve; en la fila de movil se deja solo para
   * lectores de pantalla, que ahi el sitio es el que es.
   */
  rotuloVisible?: boolean
  className?: string
}

/**
 * Conmutador de tema de tres estados.
 *
 * Son `<input type="radio">` de verdad, escondidos bajo su etiqueta, y no
 * botones con `aria-checked`: asi las flechas del teclado recorren el grupo, el
 * `<fieldset>` le pone nombre y no hay que reimplementar a mano el patron de
 * radiogroup. Lo que se ve es la etiqueta, que reacciona con `has-[:checked]`.
 *
 * El `name` sale de `useId` porque el armazon monta dos instancias -lateral y
 * movil- y dos grupos con el mismo nombre en el documento serian, para el
 * navegador, un unico grupo.
 *
 * Sin emojis ni iconos de sol y luna: las tres palabras dicen exactamente cual
 * es el estado, incluido `Sistema`, que ningun pictograma explica bien.
 */
export function ConmutadorTema({ rotuloVisible = true, className }: Props) {
  const { tema, cambiarTema } = useTema()
  const nombre = useId()

  return (
    <fieldset className={className}>
      <legend
        className={
          rotuloVisible
            ? 'text-xs font-semibold uppercase tracking-widest text-tinta-apagada'
            : 'sr-only'
        }
      >
        Tema
      </legend>

      <div
        className={`grid grid-cols-3 gap-1 rounded-lg border border-borde bg-elevado p-1 ${
          rotuloVisible ? 'mt-2' : ''
        }`}
      >
        {TEMAS.map((opcion) => (
          <label
            key={opcion}
            className={[
              'cursor-pointer rounded-md px-2 py-1.5 text-center text-xs font-medium transition-colors',
              'text-tinta-2 hover:text-tinta',
              'has-[:checked]:bg-superficie has-[:checked]:text-acento-tinta has-[:checked]:ring-1 has-[:checked]:ring-acento-borde',
              'has-[:focus-visible]:ring-2 has-[:focus-visible]:ring-foco',
            ].join(' ')}
          >
            <input
              type="radio"
              name={nombre}
              value={opcion}
              checked={tema === opcion}
              onChange={() => cambiarTema(opcion)}
              className="sr-only"
            />
            {ETIQUETAS[opcion]}
          </label>
        ))}
      </div>
    </fieldset>
  )
}
